<template>
  <div>
    <SearchNavHeader :currentPage="'searchProducts'"/>
    <div class="container-fluid">
      <div class="row">
        <div class="col-12 col-md-8 col-lg-6 mx-auto">
      <div class="row mt-4">
        <div class="col-12 text-center">
          <v-combobox
              v-if="showSearchBox"
              v-model="searchKeyWord"
              append-icon="far fa-search"
              class="rounded-lg search-combobox"
              dense
              :return-object="false"
              flat
              clearable
              :items="productsListItems"
              @click:clear="clearSearchHistory"
              hide-details
              placeholder="جستجو در محصولات..."
              solo
              @click:append="searchBtn"
              @keyup="search($event)"></v-combobox>

          <span v-else class=" rounded-xl bg-white py-2 px-3 d-inline-block position-relative">
             {{ searchKeyWord }}
             <v-btn class=" pl-1 close-search-key-btn" icon small @click="removeSearchKeyword"><i
                 class="fa-regular fa-circle-xmark pointer font16px "></i></v-btn>
          </span>
        </div>
      </div>
      <div class="min-height-300px">
      <div class="row">
        <div class="col-12">
          <div class="row">
            <div v-if="!hasResult" class="col-12 text-center">
              نتیجه ای یافت نشد
            </div>
            <div v-else v-for="item in products" :key="item.id" class="col-12 py-0 ">
              <ProductListsCard :item="item"/>
            </div>
          </div>
        </div>
      </div>
      </div>
        </div>
      </div>
    </div>
    <v-overlay :value="showLoaderDialog">
      <div class="loading-spinner">
      </div>
    </v-overlay>
  </div>
</template>

<script>
import SearchNavHeader from "@/views/Search/SearchNavHeader";
import ProductListsCard from "@/components/ProductListsCard";

export default {
  name: "SearchProducts",
  metaInfo: {
    title: 'ایوان خانه- جستجوی محصول',
  },
  components: {ProductListsCard, SearchNavHeader},
  data: () => ({
    showSearchBox: true,
    showLoaderDialog: false,
    searchKeyWord: '',
    products: [],
    productsListItems: [],
    hasResult:true,
    latestProducts:[],
    latestProductsLoading:true
  }),
  mounted() {
    this.getProductList()
    this.initLatestProducts()
  },

  methods: {
    search(e) {
      if (e.keyCode === 13) {
        this.searchBtn()
      }
    },
    searchBtn(){
      this.showLoaderDialog = true
      let myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

      let urlencoded = new URLSearchParams();
        urlencoded.append("KeyWord",this.searchKeyWord);
      let requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: urlencoded,
        redirect: 'follow'
      };
      let resStatus = null
      fetch(this.$baseUrl + "SearchEngine/_ListProduct", requestOptions)
          .then(response => {
            resStatus = response.status
            return response.text()
          })
          .then(result => {
            if (resStatus === 200) {
              let products = JSON.parse(result);
              for (let i = 0; i < products.length; i++) {
                products[i].tip = products[i].VendorProductTipViewModels[0]

                let voteArr = products[i].VoteViewModel

                let num = voteArr.length
                let sumVote = 0
                for (let j = 0; j < voteArr.length; j++) {
                  sumVote += voteArr[j].Rate
                }
                let avg = sumVote / num;
                if (avg > 0) {
                  products[i].avgVote = sumVote / num
                } else {
                  products[i].avgVote = 0
                }
                this.products = products;
                this.showSearchBox = false
                this.hasResult = true
              }
            } else {
              this.hasResult = false

            }
            this.showLoaderDialog = false
          })
          .catch(error => console.log('error', error));
    },
    removeSearchKeyword() {
      this.showSearchBox = true
      this.searchKeyWord = null
      this.products = null
    },
    clearSearchHistory(){
      this.hasResult= true
    },
    initLatestProducts() {
      this.showLoaderDialog= true
      let myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

      let urlencoded = new URLSearchParams();
      urlencoded.append("TypeSearchEngineSort", "جدیدترین_ها");

      let requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: urlencoded,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "SearchEngine/_ListProduct", requestOptions)
          .then(response => response.text())
          .then(result => {
            let products = JSON.parse(result);
            for (let i = 0; i < products.length; i++) {
              products[i].tip = products[i].VendorProductTipViewModels[0]

              let voteArr = products[i].VoteViewModel

              let num = voteArr.length
              let sumVote = 0
              for (let j = 0; j < voteArr.length; j++) {
                sumVote += voteArr[j].Rate
              }
              let avg = sumVote / num;
              if (avg > 0) {
                products[i].avgVote = sumVote / num
              } else {
                products[i].avgVote = 0
              }
            }
            this.products = products;
            this.showLoaderDialog=false

          }).catch(error => console.log('error', error));
    },
    getProductList(){
      let requestOptions = {
        method: 'GET',
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "Shopping/GetActiveProducts", requestOptions)
          .then(response => response.text())
          .then(result => {
            let products = JSON.parse(result)
            let items=[]
            for(let i=0;i<products.length;i++){
              items.push(products[i].Name)
            }
            this.productsListItems = items
          })
          .catch(error => console.log('error', error));
    },

  }

}
</script>

